<template>
	<div class="">
        <el-radio-group v-model="radio" @change='getVal'>
            <el-radio :label="1"></el-radio>
            <el-radio :label="2"></el-radio>
            <el-radio :label="3"></el-radio>
            <el-radio :label="4"></el-radio>
            <el-radio :label="5"></el-radio>
            <el-radio :label="6"></el-radio>
            <el-radio :label="7"></el-radio>
            <el-radio :label="8"></el-radio>
            <el-radio :label="9"></el-radio>
            <el-radio :label="10"></el-radio>
        </el-radio-group>
	</div>
</template>
<script>
export default {
    name: "scoreGroup",
    props: {
		name:{
			type:String,
			default:''
        },
        optionNum:{
            type:Number,
			default:0
        },
        isReset:{
            type:Boolean,
            default:false
        }
	},
    data() {
        return {
            radio:''
        }
    },
    mounted() {
        
    },
	watch:{
		isReset:{
            handler(newVal,oldVal){
                if(newVal){
                    this.radio = '';
                }
            },
            immediate:true
        }
	},
    methods: {
        getVal(){
            this.$emit('getchildScore',{score:this.radio,sortIndex:this.optionNum});  
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/scoreGroup.vue